import React from "react";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

const tabs = [
    {labelKey: "gps.tabs.map", link: "/gps"},
    {labelKey: "gps.tabs.assets", link: "/gps/assets"},
    {labelKey: "gps.tabs.zones", link: "/gps/zones"},
    {labelKey: "gps.tabs.rules", link: "/gps/rules"},
    {labelKey: "gps.tabs.actions", link: "/gps/actions"},
];

export default function GPSTabs({active}) {
    const {t} = useTranslation();
    return (
        <div className="d-flex flex-row gap-2 mb-3">
            {tabs.map((tab, index) => (
                <Link
                    key={index}
                    to={tab.link}
                    style={{
                        padding: '8px 16px',
                        borderRadius: '6px',
                        textDecoration: 'none',
                        fontSize: '14px',
                        fontWeight: active === index ? '600' : '400',
                        backgroundColor: active === index ? '#1E293B' : '#F1F5F9',
                        color: active === index ? '#fff' : '#64748B',
                    }}
                >
                    {t(tab.labelKey)}
                </Link>
            ))}
        </div>
    );
}
